// Coordonnées figées du Bistrot de la Neuve.
// Non modifiables via l'admin.
export const BISTRO_INFO = {
  nom: "Le Bistrot de la Neuve",
  adresse: "Zone d'Activités de La Neuve, 44 Rue du Plateau, 01440 Viriat",
  telephone: "04 74 45 35 10",
  email: "bdelaneuve@gmail.com",
};

// Téléphone nettoyé pour les liens `tel:`
export const BISTRO_TEL = BISTRO_INFO.telephone.replace(/\s/g, "");
